import { QuestionnaireSectionsForNavigation } from "../../../../../api/src/types";
import type { AnswersWithAttorneyRestrictionsGetResponse } from "../../../../../api/src/users/answers/route";

export const getSectionVisibility = (
  sections: QuestionnaireSectionsForNavigation[] | undefined,
  currentSection: QuestionnaireSectionsForNavigation | undefined,
  answersWithAttorneyRestrictions:
    | AnswersWithAttorneyRestrictionsGetResponse
    | undefined,
  documentStateId: string,
) => {
  const attorneyRestrictions = answersWithAttorneyRestrictions?.flatMap(
    (answer) =>
      answer.answerQuestionOptions.flatMap((option) =>
        option.questionOption.attorneyRulesByQuestionOptionState
          .filter((rule) => rule.stateId === documentStateId)
          .map((rule) => ({
            ...rule,
            parentQuestionnaireSectionId:
              answer.question.parentQuestionnaireSectionId,
          })),
      ),
  );
  if (!attorneyRestrictions || attorneyRestrictions.length === 0) {
    return true;
  }

  const sectionsWithRestrictions = sections?.filter((section) =>
    attorneyRestrictions.some(
      (restriction) => restriction.parentQuestionnaireSectionId === section.id,
    ),
  );

  const isSectionVisible = !sectionsWithRestrictions?.some(
    (section) => currentSection && currentSection.order > section.order,
  );

  return isSectionVisible;
};
